/**
 * Attribute an Ekho-owned surface sets on `<html>` to declare that it renders
 * the chat widget itself. The SDK loader checks for it and skips its own chat
 * module, because both mount paths claim the same `#ekho-shadow-host` element
 * and would otherwise stack two launchers on the page.
 *
 * Presence is the signal; the `"true"` value only makes it readable in
 * devtools. Matching on hostname shape is deliberately avoided, since
 * white-label storefront domains follow no predictable pattern.
 */
const NATIVE_CHAT_SURFACE_ATTRIBUTE = 'data-ekho-native-chat';

export { NATIVE_CHAT_SURFACE_ATTRIBUTE };
//# sourceMappingURL=SdkNativeChatSurface.js.map
